import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err);
};

const router = new Router({
  mode: "history",
  routes: [
    // cn
    { path: "/", component: () => import("@/views/cn/home/index") },
    // { path: '/', component: () => import('@/views/cn/index2') },
    { path: "/cn/cim", component: () => import("@/views/cn/solve/cim") },
    { path: "/cn/meta", component: () => import("@/views/cn/solve/meta") },
    {
      path: "/cn/natural",
      component: () => import("@/views/cn/solve/natural"),
    },
    {
      path: "/cn/village",
      component: () => import("@/views/cn/solve/village"),
    },
    {
      path: "/cn/enterpriseCooperation",
      component: () => import("@/views/cn/enterpriseCooperation"),
    },
    // { path: '/', component: () => import('@/views/cn/index2') },
    // {path: '/cn', component: () => import( '@/views/cn/index')},
    { path: "/cn/cloudapp", component: () => import("@/views/cn/cloudapp") },
    {
      path: "/cn/doublefish5b",
      component: () => import("@/views/cn/doublefish5b"),
    },
    // {
    //   path: '/cn/solnsight',
    //   component: () => import('@/views/cn/solnsight')
    // },
    {
      path: "/cn/hawkeye",
      component: () => import("@/views/cn/hawkeye"),
    },
    {
      path: "/cn/wisdomR100",
      component: () => import("@/views/cn/wisdomR100"),
    },
    {
      path: "/cn/wisdomS100",
      component: () => import("@/views/cn/wisdomS100"),
    },
    // {
    //   path: '/cn/doublefish7x',
    //   component: () => import('@/views/cn/doublefish7x')
    // },
    // {
    //   path: '/cn/doublefish7xp',
    //   component: () => import('@/views/cn/doublefish7xp')
    // },
    // {
    //   path: '/cn/doublefish8xp',
    //   component: () => import('@/views/cn/doublefish8xp')
    // },
    // {
    //   path: '/cn/doublefish8xm',
    //   component: () => import('@/views/cn/doublefish8xm')
    // },
    // {
    //   path: '/cn/doublefish5c',
    //   component: () => import('@/views/cn/doublefish5c')
    // },
    {
      path: "/cn/doublefish8x",
      component: () => import("@/views/cn/doublefish8x"),
    },
    { path: "/cn/engin", component: () => import("@/views/cn/engin2") },
    // { path: "/cn/gclient", component: () => import("@/views/cn/gclient2") },
    { path: "/cn/user", component: () => import("@/views/cn/user") },
    // rtk下载
    {
      path: "/cn/download/minirtk",
      component: () => import("@/views/cn/download/minirtk"),
    },
    {
      path: "/cn/download/DasInsightAPP",
      component: () => import("@/views/cn/download/DasInsightAPP"),
    },
    { path: "/cn/download", component: () => import("@/views/cn/download2") },
    { path: "/cn/news", component: () => import("@/views/cn/news") },
    {
      path: "/cn/newsdetail",
      component: () => import("@/views/cn/newsdetail"),
    },
    {
      path: "/cn/dataApplication",
      component: () => import("@/views/cn/dataApplication"),
    },
    { path: "/cn/cases", component: () => import("@/views/cn/cases") },
    { path: "/cn/rtk", component: () => import("@/views/cn/rtk") },
    { path: "/cn/dshot", component: () => import("@/views/cn/ds2") },
    {
      path: "/cn/casedetail",
      component: () => import("@/views/cn/casedetail"),
    },
    { path: "/cn/gcluster", component: () => import("@/views/cn/gcluster4") },

    { path: "/cn/privacy", component: () => import("@/views/cn/privacy") },
    { path: "/cn/legal", component: () => import("@/views/cn/legal") },
    { path: "/cn/login", component: () => import("@/views/cn/login") },
    { path: "/cn/regist", component: () => import("@/views/cn/regist") },
    { path: "/cn/resetpass", component: () => import("@/views/cn/resetpass") },
    { path: "/cn/desktop", component: () => import("@/views/cn/desktop") },
    { path: "/cn/about", component: () => import("@/views/cn/about3") },
    { path: "/cn/faq", component: () => import("@/views/cn/faq") },
    { path: "/cn/service", component: () => import("@/views/cn/service2") },
    { path: "/cn/wise", component: () => import("@/views/cn/wise2") },
    { path: "/cn/mofang", component: () => import("@/views/cn/mofang2") },
    { path: "/cn/dasviewer", component: () => import("@/views/cn/dasviewer2") },
    // {path: '/cn/videos', component: () => import( '@/views/cn/videos')},
    // {path: '/cn/videodetail', component: () => import( '@/views/cn/videodetail')},
    { path: "/cn/cloud", component: () => import("@/views/cn/cloud") },
    { path: "/cn/nongchang", component: () => import("@/views/cn/nongchang3") },
    { path: "/cn/sustain", component: () => import("@/views/cn/sustain") },
    // { path: "/cn/viewer", component: () => import("@/views/cn/viewer") },
    // { path: "/cn/mycloud", component: () => import("@/views/cn/mycloud") },
    {
      path: "/cn/taskDetail",
      component: () => import("@/views/cn/taskDetail"),
    },
    {
      path: "/cn/modelview",
      component: () => import("@/views/cn/modelviewblank"),
    },
    {
      path: "/cn/dasmesh",
      component: () => import("@/views/cn/dasmesh"),
    },
    { path: "/cn/nrs", component: () => import("@/views/cn/nrs") },
    { path: "/cn/mine", component: () => import("@/views/cn/mine") },
    { path: "/cn/farmhouse", component: () => import("@/views/cn/farmhouse") },
    {
      path: "/cn/DV-publicity",
      component: () => import("@/views/cn/dvpublicity"),
    },
    // 便携农场
    { path: "/cn/farmlite", component: () => import("@/views/cn/farmlite") },
    // 便携农场
    {
      path: "/cn/farmsecurity",
      component: () => import("@/views/cn/farmsecurity"),
    },
    // 应急解决方案
    { path: "/cn/emergency", component: () => import("@/views/cn/emergency") },
    // 低空云
    { path: "/cn/skyCloud", component: () => import("@/views/cn/lowercloud") },
    // en
    // {path: '/en', component: () => import( '@/views/en/gclient')},
    { path: "/en/engin", component: () => import("@/views/en/engin") },
    { path: "/en/gclient", component: () => import("@/views/en/gclient") },
    { path: "/en/privacy", component: () => import("@/views/en/privacy") },
    { path: "/en/legal", component: () => import("@/views/en/legal") },
    { path: "/en/login", component: () => import("@/views/en/login") },
    { path: "/en/regist", component: () => import("@/views/en/regist") },
    { path: "/en/resetpass", component: () => import("@/views/en/resetpass") },
    { path: "/en/desktop", component: () => import("@/views/en/desktop") },
    { path: "/en/about", component: () => import("@/views/en/about") },
    { path: "/en/download", component: () => import("@/views/en/download") },
    //重建大师卫星
    {
      path: "/cn/cluster-satellite",
      component: () => import("@/views/cn/cluster-satellite"),
    },

    // 容错
    { path: "*", redirect: "/" },
  ],
});
//贴图大师阶段性隐藏
if (applimit.mplimit.enable) {
  let endTime = applimit.mplimit.endTime.split("-").join(" ");
  let start = applimit.mplimit.startTime.split("-").join(" ");
  if (
    new Date().getTime() > Date.parse(endTime) + 24 * 60 * 60 * 1000 ||
    new Date().getTime() < Date.parse(start)
  ) {
    router.addRoutes([
      {
        path: "/cn/mp",
        component: () => import("@/views/cn/mp"),
      },
    ]);
    router.addRoutes([
      {
        path: "/cn/verification",
        component: () => import("@/views/cn/verification"),
      },
    ]);
  }
} else {
  router.addRoutes([
    {
      path: "/cn/mp",
      component: () => import("@/views/cn/mp"),
    },
  ]);
  router.addRoutes([
    {
      path: "/cn/verification",
      component: () => import("@/views/cn/verification"),
    },
  ]);
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js